
export default {

    settings(state,data){
        state.settings = data
    },

    setting(state,data){
        state.setting = data
    },

    referralBonusSetting(state,data){
        state.referralBonusSetting = data
     },

     upgradeBonusSetting(state,data){
        state.upgradeBonusSetting = data
     },

    unilevelBonusSetting(state,data){
        state.unilevelBonusSetting = data
    },

    stockistUplineBonusSetting(state,data){
        state.stockistUplineBonusSetting = data
    }
}